// import React from "react";
// import AccessControlHead from "./TableHead/AccessControlHead";
// import AccessControlBody from "./TableBody/AccessControlBody";

// const AccessControlTable = ({
//   permissionsAccessControl,
//   accessControls,
//   handleDelete,
//   status,
//   handleOpenPopup,
// }) => {
//   return (
//     <div className="row">
//       <div className="col-12">
//         <div className="card">
//           <div className="card__body">
//             <div className="table-wrapper">
//               <table>
//                 <AccessControlHead
//                   permissionsAccessControl={permissionsAccessControl}
//                   status={status}
//                 />

//                 <AccessControlBody
//                   accessControls={accessControls}
//                   handleOpenPopup={handleOpenPopup}
//                   handleDelete={handleDelete}
//                   status={status}
//                 />
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

import React from "react";
import ReusableDataTable from "src/components/table/ReusableDataTable";
import GetAccessControlTableColumn from "./ColumnDefinition/AccessControlColumn/GetAccessControlTableColumn";
import { mapAccessControlToDataTable as mapData } from "./Helper";

const AccessControlTable = ({
  data,
  handleDelete,
  handleOpenPopup,
  status,
}) => {
  const columns = GetAccessControlTableColumn({
    handleDelete,
    handleOpenPopup,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default AccessControlTable;
